import { ModalDialog } from 'core-components/library/modalDialog'

import { AffectedLPModalContent } from './AffectedLPModalContent'

interface IProps {
  onAgree: () => void
  show: boolean
  onCancel: () => void
  affectedLPCount: number
  headerTranslation: string
  textTranslation: string
}

export const AffectedLPModal = ({
  show,
  affectedLPCount,
  onCancel,
  onAgree,
  textTranslation,
  headerTranslation,
}: IProps) => {
  return (
    <ModalDialog
      show={show}
      onClose={onCancel}
      closeOnOutsideClick={false}
      content={AffectedLPModalContent}
      size="sm"
      contentProps={{
        affectedLPCount,
        onAgree,
        onCancel,
        textTranslation,
        headerTranslation,
      }}
    />
  )
}
